module.exports = require("sharedb/lib/client");